import { API_ROUTES } from '@/constants/apiRoutes';
import { ProfileFormValues, UserResponse } from '@/types/user';
import { api } from '@/utils/api';

export const getUserInfoService = async () => {
  const { data } = await api<UserResponse>({
    url: API_ROUTES.USER,
    method: 'get',
    version: 2,
  });

  return data;
};

export const updateLastLoginDate = () => {
  api({
    url: 'users/login-info/',
    method: 'post',
  });
};

export async function updateStaffService(data: ProfileFormValues) {
  const { firstName, lastName, title, businessPhone, bio } = data;

  const { status } = await api({
    url: API_ROUTES.UPDATE_STAFF_PROFILE,
    method: 'put',
    version: 2,
    data: {
      first_name: firstName,
      last_name: lastName,
      title,
      business_phone_number: businessPhone,
      bio: bio || '',
    },
  });

  return status;
}

export async function updateAdvisorService(data: ProfileFormValues) {
  const {
    firstName,
    lastName,
    title,
    businessPhone,
    supportMembers,
    personalBankLink,
    bio,
  } = data;
  const support_members = supportMembers.map(member => member.value);

  const { status } = await api({
    url: API_ROUTES.UPDATE_ADVISOR_PROFILE,
    method: 'put',
    version: 2,
    data: {
      first_name: firstName,
      last_name: lastName,
      title,
      business_phone_number: businessPhone,
      bio: bio || '',
      alias: personalBankLink,
      support_members: support_members,
    },
  });

  return status;
}
